import "./DesignationsTabUI.css";

import { FC, useEffect, useMemo, useState } from "react";

import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { DesignationService } from "../../../../../services/DesignationService";
import { DesignationsTabToolbar } from "./DesignationsTabToolbar/DesignationsTabToolbar";
import { Dropdown } from "primereact/dropdown";
import { IAppState } from "../../../../../store/reducers";
import { InputText } from "primereact/inputtext";
import { designationsInitialData } from "../../../EmployeeAssignemnt";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useTheme } from "@mui/material";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity } from "@websential/cosmic-v20";
import { sortDDLByLabel } from "../../../../../common/Common";

let emptyDesignation = {
	id: null,
	designations: "",
	fromDate: null,
	toDate: null,
	notes: "",
	rowWithRandomId: true
};

const useGetDesignationDDL = (clientId: string) =>
	useQuery({
		queryKey: ["designation-ddl", clientId],
		queryFn: () => {
			return DesignationService.getGetDesignationDDL(clientId);
		},
		refetchOnWindowFocus: false,
	});

interface IDesignationsTabsPanel {
	designationsUpdatedData: (data: any) => void;
	designationsDataItems: any;
	TabTableheaderColumns: any;
	selectedEmployeeLabel: string;
	onRowDeleteClicked: (data: any) => void;
}
export const DesignationsTabsPanel: FC<IDesignationsTabsPanel> = ({
	designationsUpdatedData,
	designationsDataItems,
	TabTableheaderColumns,
	selectedEmployeeLabel,
	onRowDeleteClicked,
}) => {
	const theme = useTheme();
	const [selectedDesignations, setSelectedDesignations] = useState<any>(null);
	const [designations, setDesignations] = useState<any>(designationsDataItems);
	const [designation, setDesignation] = useState(emptyDesignation);
	const [lastAddedRowId, setLastAddedRowId] = useState<any>(null);
	const clientId = useSelector((state: IAppState) => state.client.id);

	const { data: designationsDDL, isLoading: isLoading } =
		useGetDesignationDDL(clientId);
	const designationsDDLItems = useMemo(() => {
		if (designationsDDL && Array.isArray(designationsDDL)) {
			let resources: any[] = sortDDLByLabel(designationsDDL).map((resourceItem: any) => ({
				id: resourceItem.id,
				label: resourceItem.label,
				value: resourceItem.value,
			}));
			resources.unshift({
				label: "--",
				value: null,
			});
			return resources;
		}
		return [
			{
				label: "--",
				value: null,
			},
		];
	}, [designationsDDL]);

	useEffect(() => {
		designationsUpdatedData(designations);
	}, [designations]);

	useEffect(() => {

		setDesignations(designationsDataItems);
	}, [designationsDataItems]);

	const findIndexById = (id: string | number | any) => {
		let index = -1;

		for (let i = 0; i < designations.length; i++) {
			if (designations[i].id === id) {
				index = i;
				break;
			}
		}

		return index;
	};

	const createId = () => {
		let id = "";
		let chars =
			"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (let i = 0; i < 5; i++) {
			id += chars.charAt(Math.floor(Math.random() * chars.length));
		}

		return id;
	};

	// const openNew = () => {
	// 	// alert("new")

	// 	let _designations = [...designations];
	// 	let _designation: any = { ...designation };

	// 	if (designation.id) {
	// 		const index = findIndexById(designation.id);

	// 		_designations[index] = _designation;
	// 	} else {
	// 		_designation.id = createId();
	// 		_designations.push(_designation);
	// 	}



	// 	setDesignations(_designations);
	// 	setDesignation(emptyDesignation);
	// };

	const openNew = () => {
		// if (employeeStatus && employeeStatus.length >= 4) return null;
		let _designationsSetupPanelData = [...designations];
		let _designationSetupPanelNewRow: any = { ...designation };

		if (designation.id) {
			const rowIndex = findIndexById(designation.id);
			_designationsSetupPanelData[rowIndex] = _designationSetupPanelNewRow;

		} else {
			const newRowId = createId();
			_designationSetupPanelNewRow.id = newRowId;
			_designationsSetupPanelData.push(_designationSetupPanelNewRow);
			setLastAddedRowId(newRowId && newRowId);

		}
		setDesignations(_designationsSetupPanelData);
		setDesignation(emptyDesignation);
	};

	const onCellValueChange = (event: any, rowIndex: number, field: any) => {
		// const updatedData = [...designations];
		// updatedData[rowIndex][event.field] = field;
		// setDesignations(updatedData);

		setDesignations((prev: any) => {
			const updatedData = [...prev];
			const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
			updatedData[rowIndex] = updatedRow;
			return updatedData;
		});
	};

	const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
		if (field.field === "fromDate") {
			if (
				rowData.designations !== "" &&
				rowData.designations !== undefined &&
				rowData.designations !== null
			) {
				if (rowData.fromDate === null) {
					return "p-component p-filled calender-error-input";
				} else if (rowData.fromDate === "") {
					return "p-component p-filled calender-error-input";
				}
			}
		} else if (field.field === "designations") {
			if (
				rowData.fromDate !== "" &&
				rowData.fromDate !== undefined &&
				rowData.fromDate !== null
			) {
				if (rowData.designations === null) {
					return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
				} else if (rowData.designations === "") {
					return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
				}
			} else {
				return "p-component p-filled input-dropdown-fields .p-dropdown";
			}
		} else {
			return "p-component p-filled input-dropdown-fields";
		}
	};

	const columnsBody = (rowData: any, row: any, x: any) => {
		if (x.field === "label") {
			return (
				<span>
					<b>
						Select Designation 
					</b>
				</span>
			);
		} else if (x.field === "designations") {
			return (
				<Dropdown
					options={designationsDDLItems}
					value={rowData.designations}
					onChange={(e: any) =>
						onCellValueChange(x, row.rowIndex, e.target.value)
					}
					placeholder="--"
					className={renderErrorClass(x, row.rowIndex, rowData)}
					optionLabel="label"
					optionValue="value"
				/>
			);
		} else if (x.field === "fromDate") {
			return (
				<Calendar
					id="fromDate"
					value={rowData[x.field]}
					showIcon
					// className="calender"
					style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					dateFormat="M dd, yy"
					placeholder={"dd/mm/yyyy"}
					showButtonBar
					className={`calender ${renderErrorClass(x, row.rowIndex, rowData)}`}
				/>
			);
		} else if (x.field === "toDate") {
			return (
				<Calendar
					id="fromDate"
					value={rowData[x.field]}
					showIcon
					className="calender"
					style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
					dateFormat="M dd, yy"
					placeholder={"dd/mm/yyyy"}
					showButtonBar
				/>
			);
		} else if (x.field === "notes") {
			return (
				<InputText
					value={rowData[x.field]}
					onChange={(e: any) =>
						onCellValueChange(x, row.rowIndex, e.target.value)
					}
					placeholder="Write notes here"
					className={"notesField p-component p-filled input-dropdown-fields"}
				/>
			);
		}
	};


	const onDeleteNewAddedRow = (rowId: any) => {
		setDesignations((prev: any[]) => {
			const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);

			if (rowDeleteBasedOnId.length > 1) {
				const lastRowId = rowDeleteBasedOnId[rowDeleteBasedOnId.length - 1].id;
				setLastAddedRowId(lastRowId);
			} else {
				setLastAddedRowId(null);
			}
			return rowDeleteBasedOnId;
		});
	}
	return (
		<>
			{designationsDDL ? (
				<div className="card">
					<DesignationsTabToolbar
						openNew={openNew}
						selectedEmployeeLabel={selectedEmployeeLabel}
					/>
					<DataTable
						value={designations}
						// key={JSON.stringify(designationsDDLItems)}
						// selection={selectedDesignations}
						// onSelectionChange={(e) => setSelectedDesignations(e.value)}
						dataKey="id"
						key={lastAddedRowId}
						showGridlines
						className="DesignationsTab"
						editMode="cell"
						resizableColumns
						columnResizeMode="expand"
						scrollable
						// reorderableColumns
						filterDisplay="menu"
						loading={isLoading}
						// selectionMode="checkbox"
						scrollHeight="516px"
					>
						{TabTableheaderColumns.map((x: any, index: any) => {
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									headerTooltip={x.description}
									headerTooltipOptions={{ position: "top" }}
									sortable={false}
									// resizeable={x.resizable}
									// dataType={x.type}
									align={x.align}
									alignHeader={x.headerAlign}
									reorderable={false}
									// exportable={x.disableExport}
									frozen={x.frozenColumn}
									columnKey={x.field}
									style={{
										width: x.minWidth,
										fontSize: "0.875rem",
									}}
									footer={x.footer}
									body={(rowData: any, row: any) =>
										columnsBody(rowData, row, x)
									}
								/>
							);
						})}


						{/* <Column
							body={(rowData: any, row: any) => {
								const showIcon = rowData.id === lastAddedRowId;
								return showIcon ? (
									<EnhancedButtonPrimeReact
										icon="pi pi-times"
										severity={EnhancedButtonPrimeReactSeverity.Danger}
										className="p-button-rounded p-button-text shadow-none bg-transparent"
										rounded
										// onClickHandler={onDeleteNewAddedRow}
										onClickHandler={() => onDeleteNewAddedRow(rowData.id)}
									/>
								) : null;
							}}
						/> */}


						<Column
							body={(rowData: any, row: any) => {
								const isLastRow = row.rowIndex === designations.length - 1;
								console.log("isLastRow", isLastRow)
								return isLastRow ? (
									<EnhancedButtonPrimeReact
										icon="pi pi-times"
										severity={EnhancedButtonPrimeReactSeverity.Danger}
										className="p-button-rounded p-button-text shadow-none bg-transparent  delete-row-btn"
										rounded
										onClickHandler={() => rowData.rowWithRandomId ? onDeleteNewAddedRow(rowData.id) : onRowDeleteClicked(rowData)}
									/>
								) : null;
							}}
						/>

					</DataTable>
				</div>
			) : (
				<></>
			)}
		</>
	);
};
